// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteRouteImport } from './routes/_protected/route'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedCompletionIndexRouteImport } from './routes/_protected/completion/index'
import { Route as ProtectedFinalDeliveryIndexRouteImport } from './routes/_protected/final-delivery/index'
import { Route as ProtectedPaymentDetailsIndexRouteImport } from './routes/_protected/payment-details/index'
import { Route as PublicAuthorizeIndexRouteImport } from './routes/_public/authorize/index'
import { Route as PublicLinkExpiredIndexRouteImport } from './routes/_public/link-expired/index'

const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedCompletionIndexRoute = ProtectedCompletionIndexRouteImport.update({
            id: '/completion/',path: '/completion/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedFinalDeliveryIndexRoute = ProtectedFinalDeliveryIndexRouteImport.update({
            id: '/final-delivery/',path: '/final-delivery/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedPaymentDetailsIndexRoute = ProtectedPaymentDetailsIndexRouteImport.update({
            id: '/payment-details/',path: '/payment-details/',getParentRoute: () => ProtectedRouteRoute
          })
const PublicAuthorizeIndexRoute = PublicAuthorizeIndexRouteImport.update({
            id: '/_public/authorize/',path: '/authorize/',getParentRoute: () => rootRouteImport
          })
const PublicLinkExpiredIndexRoute = PublicLinkExpiredIndexRouteImport.update({
            id: '/_public/link-expired/',path: '/link-expired/',getParentRoute: () => rootRouteImport
          })





const ProtectedRouteRouteChildren = {
  ProtectedIndexRoute: ProtectedIndexRoute,ProtectedCompletionIndexRoute: ProtectedCompletionIndexRoute,ProtectedFinalDeliveryIndexRoute: ProtectedFinalDeliveryIndexRoute,ProtectedPaymentDetailsIndexRoute: ProtectedPaymentDetailsIndexRoute
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(ProtectedRouteRouteChildren)

const rootRouteChildren = {
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,PublicAuthorizeIndexRoute: PublicAuthorizeIndexRoute,PublicLinkExpiredIndexRoute: PublicLinkExpiredIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)